import React, { useState } from "react";
import { TinyValueComponent } from "./TinyValueComponent";
import { DatabaseObjectView } from "../../admin/DatabaseObjectView";

interface DbObjectIdComponentProps {
  value: string;
  table: string;
  label?: string;
  clipboard?: boolean;
  cropText?: boolean;
  autocolor?: boolean;
  color?: string;
  prefix?: string;
}

/**
 * A wrapper around TinyValueComponent that opens the Database Object Viewer
 * when clicked, displaying the object with the given ID and table/schema.
 */
export const DbObjectIdComponent: React.FC<DbObjectIdComponentProps> = ({
  value,
  table,
  label,
  clipboard = true,
  cropText = true,
  autocolor,
  color,
  prefix,
}) => {
  const [viewerOpen, setViewerOpen] = useState(false);

  const handleClick = () => {
    setViewerOpen(true);
  };

  return (
    <>
      <TinyValueComponent
        value={value}
        label={label}
        clipboard={clipboard}
        cropText={cropText}
        autocolor={autocolor}
        color={color}
        prefix={prefix}
        onClick={handleClick}
      />
      <DatabaseObjectView
        open={viewerOpen}
        onClose={() => setViewerOpen(false)}
        initialTable={table}
        initialId={value}
        autoFetch
      />
    </>
  );
};
